export default __webpack_public_path__ + "static/media/Redblood Cloak.4a190c5b.jpg";